import { useState } from 'react';
import { JobCodeOption } from 'app/pages/overview/tabs/transactions/types';
import { Autocomplete, Box, Icon, Tooltip } from '@mui/material';
import { filledTextField, unassignedTextField } from 'app/pages/overview/tabs/transactions/utils';

interface JobCodesDropdownProps {
  selectedJobCode?: JobCodeOption | null;
  options: JobCodeOption[] | undefined;
  isDeprecated: boolean;
  onValueChange: (jobCodeOption: JobCodeOption | null) => void;
  fullWidth?: boolean;
}

const JobCodesDropdown = ({
  selectedJobCode,
  options = [],
  onValueChange,
  isDeprecated,
  fullWidth = false,
}: JobCodesDropdownProps) => {
  const [open, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState('');

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }} onClick={(e) => e.stopPropagation()}>
      {isDeprecated && (
        <Tooltip title="This job code belongs to an outdated import file">
          <Icon sx={{ fontSize: '8px', color: '#FF8F00', mr: 0.5 }}>report_problem</Icon>
        </Tooltip>
      )}
      <Tooltip title={selectedJobCode?.label || ''} placement="top">
        <Autocomplete
          value={selectedJobCode}
          open={open}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          onChange={(e, newValue: JobCodeOption | null) => {
            e?.stopPropagation();
            onValueChange(newValue);
          }}
          inputValue={inputValue}
          onInputChange={(e, newInputValue) => {
            e?.stopPropagation();
            setInputValue(newInputValue);
          }}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          id="job-codes-dropdown"
          options={options}
          sx={{ width: fullWidth ? '100%' : 180 }}
          clearOnBlur
          renderInput={(params) => {
            return selectedJobCode ? filledTextField(params) : unassignedTextField(params);
          }}
        />
      </Tooltip>
    </Box>
  );
};

export default JobCodesDropdown;
